import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import './css/triviaPanel.css';
import './css/feedbackModal.css';
import baseUrl from './constants/config'
import './css/homepage.css';

class FeedbackModal extends Component {
  
  constructor (props) {
    super(props)
    this.onOpenModal = this.onOpenModal.bind(this)
    this.onCloseModal = this.onCloseModal.bind(this)
    this.onSendFeedback = this.onSendFeedback.bind(this)
    this.state = {
      open: false,
      inputValue: '',
      emailInput: ''
    }
  }

  onOpenModal() {
    this.setState({ open: true });
    this.props.openAction()
  };

  isOpen() {
    return this.state.open;
  }
 
  onCloseModal() {
    this.setState({ open: false });
  };

  onSendFeedback(event) {
    event.preventDefault()
    this.setState({ open: false });
    if (this.state.inputValue === "") {
      return
    }
    fetch(baseUrl + 'trivia/api/feedback', { 
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          feedback: this.state.emailInput + ': ' + this.state.inputValue
        })
      })
      .then(response => response.json())
      .then(data => {
      });
  }

  updateInputValue(evt) {
    this.setState({
      inputValue: evt.target.value
    });
  }

  updateEmailInput(evt) {
    this.setState({
      emailInput: evt.target.value
    });
  }

  /*
  <h2>Leave your feedback</h2>
            <h5>Tell us what you liked or disliked!</h5>
            <form className="feedbackForm" onSubmit={this.onSendFeedback}>
              < input type="text" 
                placeholder = "Email" 
                className = "emailInput"
                value={this.state.emailInput}
                onChange={evt => this.updateEmailInput(evt)}/>
              <textarea 
                rows="4"
                cols="50"
                type="text" 
                placeholder = "Feedback" 
                className = "feedbackInput"
                value={this.state.inputValue}
                onChange={evt => this.updateInputValue(evt)}/>
              <button className="Answer-Submit-Btn" type = "submit" onClick={this.onCloseModal} >
                <span>Submit Feedback</span>
              </button>
            </form>
  */

  render() {
    return (
      <div>
        <button onClick={this.onOpenModal} className="Homepage-button">Send Feedback</button>
        <Modal open={this.state.open} onClose={this.onCloseModal} center showCloseIcon={false}>
          <div className="feedbackContainer">
            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSezjm3YeP5Bt-GUmrt4zK9xquBt4ao4ImBQgsmG8nKLJZhczQ/viewform?embedded=true" height="640" frameborder="0" marginheight="0" marginwidth="0">載入中…</iframe>
          </div>
        </Modal>
      </div>
    );
  }
}

export default FeedbackModal;



// WEBPACK FOOTER //
// ./src/components/feedbackModal.js